import { Checkbox, FormInstance } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from '~/components';
import TransferTypeForm from './TransferTypeForm';

interface Props {
  form: FormInstance;
}

const AccountFormItems: FC<Props> = (props) => {
  const { form } = props;
  const [t] = useTranslation('payouts');
  return (
    <>
      <Form.Item name="setAsPrimary" valuePropName="checked">
        <Checkbox>{t('setAsPrimary')}</Checkbox>
      </Form.Item>
      <TransferTypeForm form={form} source={[]} />
    </>
  );
};

export default AccountFormItems;
